export default "__VITE_ASSET__BJXlY2R5__"